module.exports = __webpack_public_path__ + "fonts/GenSenRounded-M.9aa3c9c2.woff2";